import React from 'react';

const FeeSettingsFields = ({
  percent,
  onPercentChange,
  fixedEur,
  onFixedEurChange,
  onDirty,

  percentLabel = 'Percentuale',
  fixedLabel = 'Fisso (EUR)',

  percentMin = 0,
  percentMax = 100,
  percentStep = 1,

  boldLabels = true,

  percentLabelStyle,
  percentInputStyle,

  fixedLabelStyle,
  fixedInputClassName,
  fixedInputStyle
}) => {
  const LabelWrapper = ({ children }) => (boldLabels ? <strong>{children}</strong> : children);

  return (
    <>
      <div>
        <label style={{ display: 'block', marginBottom: 6, ...(percentLabelStyle || {}) }}>
          <LabelWrapper>
            {percentLabel} ({Number(percent) || 0}%)
          </LabelWrapper>
        </label>
        <input
          type="range"
          min={percentMin}
          max={percentMax}
          step={percentStep}
          value={Number(percent) || 0}
          onChange={(e) => {
            onPercentChange?.(Number(e.target.value));
            onDirty?.();
          }}
          onInput={() => onDirty?.()}
          style={{ width: '100%', ...(percentInputStyle || {}) }}
        />
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: 6, ...(fixedLabelStyle || {}) }}>
          <LabelWrapper>{fixedLabel}</LabelWrapper>
        </label>
        <input
          type="number"
          inputMode="decimal"
          min="0"
          step="0.01"
          value={fixedEur}
          onChange={(e) => {
            onFixedEurChange?.(e.target.value);
            onDirty?.();
          }}
          onInput={() => onDirty?.()}
          className={fixedInputClassName}
          style={{ width: '100%', ...(fixedInputStyle || {}) }}
          placeholder="0.00"
        />
      </div>
    </>
  );
};

export default FeeSettingsFields;
